export const dataSetParte = [
  {
    nome: "Réu",
    value:"reu",
    marcado: false,
    fixo: false,
  },
  {
    nome: "Autor",
    value:"autor",
    marcado: false,
    fixo: false,
  },
  {
    nome: "Advogado Autor",
    value: "advogadoautor",
    marcado: false,
    fixo: false
  },
  {
    nome: "Advogado Réu",
    value: "advogadoreu",
    marcado: false,
    fixo: false
  },
];
